<template>
    <div class="modal" id="vehicleDeliveryModal" tabindex="-1" role="dialog" aria-labelledby="vehicleDeliveryModal" aria-hidden="true">
        <div class="modal-dialog" role="document" style="border-radius: 0 !important;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-dark" id="exampleModalLabel">
                        Informationen zur Verfügbarkeit
                    </h5>

                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times-circle text-dark"></i>
                    </button>
                </div>
                <div class="modal-body text-dark text-left small">
                    Die Verfügbarkeit des Fahrzeugs setzt sich immer aus folgenden Faktoren zusammen:

                    <div class="row mt-3">
                        <div class="col-4">
                            <div class="container">
                                <div class="circle">
                                    <img src="/img/icon-car-roof.svg" alt="Icon first"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-8 d-flex justify-content-center align-items-center">
                            <div>Sofern das Fahrzeug im Lager des Abo-Partners ist...</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <div class="container">
                                <div class="line"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <div class="container">
                                <div class="circle">
                                    <img src="/img/icon-car-top.svg" alt="Icon second"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-8 d-flex justify-content-center align-items-center">
                            <div>...benötigt der Abo-Partner in der Regel 2 - 3 Werktage um das Fahrzeug abgabefertig zu machen...</div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-4">
                            <div class="container">
                                <div class="line"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <div class="container">
                                <div class="circle">
                                    <img src="/img/icon-car-transporter.svg" alt="Icon third"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-8 d-flex justify-content-center align-items-center">
                            <div>...und wenn du dir das Fahrzeug liefern lassen möchtest, kommt noch die Lieferzeit hinzu.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AvailabilityModal",
       
    }
</script>

<style scoped>
.modal-content {
    border-radius: unset;
    border: unset;
    -webkit-border-radius: 0px !important;
    -moz-border-radius: 0px !important;
    border-radius: 0px !important; 
    padding: 2em;
}
.modal-header {
    border-bottom: unset;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    position: relative;
    background-color: #f2f2f2;
    display: flex;
    justify-content: center;
    align-items: center;
}

.line {
    width: 2px;
    height: 30px;
    border: 2px dashed #f2f2f2;
}

</style>